export const snackbarEvent = (event: string) => `Snackbar. ${event}`

export const SNACKBAR_DISPLAYED = snackbarEvent('Displayed.')
export const SNACKBAR_ACTION_BTN_CLICK = snackbarEvent('Action Button. Click.')
